app.factory("ImageChange", ["$http",
    function ($http) {
        var ImageChange = {};

        ImageChange.list = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            return $http.get("/file/image/list", {
                params: {
                    page: params.page,
                    limit: params.limit
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        ImageChange.prove = function (imageId) {
            return $http.post("/file/image/prove", {
                imageId: imageId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ImageChange.deny = function (imageId) {
            return $http.post("/file/image/deny", {
                imageId: imageId
            }).then(function (resp) {
                return resp.data;
            });
        };

        return ImageChange;
    }
]);